import { render, staticRenderFns } from "./editPermission.vue?vue&type=template&id=5a50c8cb&"
import script from "./editPermission.vue?vue&type=script&lang=js&"
export * from "./editPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports